export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          精选专题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14">
          精心策划的电影专题，发现更多好片
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {/* Topic 1 */}
          <div className="bg-background-100 border border-background-200/60 rounded-lg overflow-hidden hover:border-primary-500/30 transition-colors group cursor-default">
            <div className="relative h-48 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20collage%20with%20galaxy%20nebula%20and%20spaceship%20elements%2C%20dark%20atmosphere%20with%20golden%20and%20teal%20accent%20lighting%2C%20epic%20futuristic%20visual%20with%20stars%20and%20cosmic%20dust%2C%20movie%20poster%20aesthetic%20on%20deep%20black%20background%2C%20dramatic%20composition%2C%20premium%20cinema%20art%20style&width=800&height=480&seq=carousel-topic-01&orientation=landscape"
                alt="科幻巨制系列连映"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105 object-top"
                width="800"
                height="480"
              />
              <div className="absolute top-3 left-3">
                <span className="px-2 py-0.5 rounded text-xs bg-accent-500/90 text-white font-medium">专题</span>
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-background-100 via-transparent to-transparent"></div>
            </div>
            <div className="p-5">
              <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2">科幻巨制系列连映</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">从《星际穿越》到《沙丘》，精选科幻片高清播放十大必看神作，一次看过瘾。</p>
            </div>
          </div>

          {/* Topic 2 */}
          <div className="bg-background-100 border border-background-200/60 rounded-lg overflow-hidden hover:border-primary-500/30 transition-colors group cursor-default">
            <div className="relative h-48 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Action%20movie%20kung%20fu%20dynamic%20scene%20with%20dramatic%20martial%20arts%20silhouette%20against%20warm%20red%20and%20gold%20background%2C%20cinematic%20lighting%20with%20dust%20particles%2C%20intense%20motion%20blur%20effect%2C%20dark%20theater%20atmosphere%2C%20heroic%20composition%2C%20movie%20promotional%20style&width=800&height=480&seq=carousel-topic-02&orientation=landscape"
                alt="成龙动作片全回顾"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105 object-top"
                width="800"
                height="480"
              />
              <div className="absolute top-3 left-3">
                <span className="px-2 py-0.5 rounded text-xs bg-accent-500/90 text-white font-medium">企划</span>
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-background-100 via-transparent to-transparent"></div>
            </div>
            <div className="p-5">
              <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2">成龙动作片全回顾</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">动作片在线频道特别企划：从《警察故事》到《十二生肖》，重温功夫喜剧巅峰时代。</p>
            </div>
          </div>

          {/* Topic 3 */}
          <div className="bg-background-100 border border-background-200/60 rounded-lg overflow-hidden hover:border-primary-500/30 transition-colors group cursor-default">
            <div className="relative h-48 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20and%20vibrant%20comedy%20movie%20theme%20with%20bright%20yellow%20and%20coral%20color%20palette%2C%20playful%20decorative%20elements%20floating%20in%20warm%20light%2C%20joyful%20and%20lighthearted%20cinema%20atmosphere%2C%20golden%20spotlight%20effect%2C%20dark%20theater%20background%2C%20celebration%20movie%20poster%20design&width=800&height=480&seq=carousel-topic-03&orientation=landscape"
                alt="暑期喜剧片大放送"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105 object-top"
                width="800"
                height="480"
              />
              <div className="absolute top-3 left-3">
                <span className="px-2 py-0.5 rounded text-xs bg-accent-500/90 text-white font-medium">合集</span>
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-background-100 via-transparent to-transparent"></div>
            </div>
            <div className="p-5">
              <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2">暑期喜剧片大放送</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">喜剧片免费看暑期档最全合集！开心麻花、徐峥、黄渤爆笑经典一站式畅享。</p>
            </div>
          </div>

          {/* Topic 4 */}
          <div className="sm:col-span-2 lg:col-span-2 bg-background-100 border border-background-200/60 rounded-lg overflow-hidden hover:border-primary-500/30 transition-colors group cursor-default flex flex-col sm:flex-row">
            <div className="relative w-full sm:w-64 flex-shrink-0 h-48 sm:h-auto overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Vintage%20classic%20film%20aesthetic%20with%20old%20film%20reel%20and%20nostalgic%20warm%20sepia%20tones%2C%20elegant%20art%20deco%20movie%20theater%20elements%2C%20golden%20age%20Hollywood%20glamour%20with%20soft%20dramatic%20lighting%2C%20timeless%20cinema%20atmosphere%20on%20deep%20charcoal%20background%2C%20premium%20restoration%20visual&width=800&height=480&seq=carousel-topic-04&orientation=landscape"
                alt="经典电影全集修复计划"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105 object-top"
                width="800"
                height="480"
              />
              <div className="absolute top-3 left-3">
                <span className="px-2 py-0.5 rounded text-xs bg-accent-500/90 text-white font-medium">修复</span>
              </div>
            </div>
            <div className="flex-1 p-5 flex flex-col justify-center">
              <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2">经典电影全集修复计划</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">经典电影全集持续扩容！90年代港片百部4K修复版上线，重温黄金时代的银幕传奇。</p>
            </div>
          </div>

          {/* Topic 5 */}
          <div className="sm:col-span-2 lg:col-span-2 bg-background-100 border border-background-200/60 rounded-lg overflow-hidden hover:border-primary-500/30 transition-colors group cursor-default flex flex-col sm:flex-row">
            <div className="relative w-full sm:w-64 flex-shrink-0 h-48 sm:h-auto overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Mysterious%20suspense%20thriller%20visual%20with%20dramatic%20shadow%20play%20and%20enigmatic%20silhouette%2C%20dark%20cinematic%20atmosphere%20with%20subtle%20crimson%20accents%2C%20film%20noir%20inspired%20lighting%20with%20venetian%20blind%20shadow%20patterns%2C%20intriguing%20detective%20theme%2C%20deep%20moody%20black%20background&width=800&height=480&seq=carousel-topic-05&orientation=landscape"
                alt="悬疑烧脑片马拉松"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105 object-top"
                width="800"
                height="480"
              />
              <div className="absolute top-3 left-3">
                <span className="px-2 py-0.5 rounded text-xs bg-accent-500/90 text-white font-medium">精选</span>
              </div>
            </div>
            <div className="flex-1 p-5 flex flex-col justify-center">
              <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2">悬疑烧脑片马拉松</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">高智商影迷必看！精选悬疑反转神作，每部都让你猜不到结局，挑战大脑极限。</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}